<nav class="table-nav component">
  <div class="custom-overflow">
    <ul role=menu>
      <li role=menuitem *ngFor="let tab of tabs">
        <a [routerLink]="[]"
           (click)="onClickTab(tab)"
           [class.selected]="(tab.payload && tab.payload.isSelected)"
           [ngStyle]="{ 'border-bottom-color': (tab.payload && tab.payload.isSelected) && opCoColor} ">
          <div *ngIf="tab.template else text">
            <ng-container ngTemplateOutlet="tab.template"></ng-container>
          </div>
          <ng-template #text>
            <span class=copy>{{ tab.text }}</span>
          </ng-template>
        </a>
      </li>
    </ul>
  </div>
</nav>
